<template>
  <div class="mobile-nav">
    <div v-if="!opened" class="main-menu">
      <div class="item-block" @click="showSection('tdb-dealroom')">
        <menu-item
          text="TDB Deal Room"
          caption="Great funding opportunities for African businesses"
        />
        <arrow-right />
      </div>
    </div>

    <div v-if="opened" class="nav-details">
      <div class="details-header">
        <arrow-left @click="showMainMenu" />
        <h4>{{ selectedTitle }}</h4>
      </div>
      <tdb-dealroom-menu
        v-if="opened === 'tdb-dealroom'"
        class="opened-menu"
        @hide="hide"
        v-on-clickaway="hide"
      />
    </div>
  </div>
</template>

<script>
import ArrowRight from 'assets/images/icons/arrow-right.svg?inline'
import ArrowLeft from 'assets/images/icons/arrow-left.svg?inline'
import TdbDealroomMenu from 'theme/layout/menu/tdb-dealroom-menu'
import MenuItem from 'theme/layout/menu/menu-item'
import { mixin as clickaway } from 'vue-clickaway'

export default {
  name: 'mobile-nav',
  mixins: [clickaway],
  components: {
    ArrowRight,
    ArrowLeft,
    TdbDealroomMenu,
    MenuItem,
  },
  data() {
    return {
      opened: '',
    }
  },
  computed: {
    selectedTitle() {
      const titles = {
        'tdb-dealroom': 'TDB Deal Room',
      }
      return titles[this.opened] || ''
    },
    userId() {
      return this.$store.state.user.currentUser.userId || 'guest'
    },
  },
  methods: {
    showSection(title) {
      this.opened = title
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'show-section-menu-mobile ' + title,
        eventLabel: 'UserID ' + this.userId,
      })
      this.$gtag.event('show-section-menu-mobile ' + title, {
        'event_category': 'Click',
        'event_label': 'UserID ' + this.userId,
      })
    },
    showMainMenu() {
      this.opened = ''
    },
    hide() {
      this.$emit('hide')
    },
  },
}
</script>

<style lang="scss" scoped>
.mobile-nav {
  height: 100%;
  width: 300px;
  position: fixed;
  z-index: 9000;
  top: 0;
  right: 0;
  background-color: #eee;
  overflow-x: hidden;
  padding-top: $padding-xl;
  transition: 0.5s;
}
.item-block {
  display: flex;
  justify-content: space-between;
  margin-bottom: $margin-m;
  padding: $padding-m;
  cursor: pointer;
  transition: background-color 0.2s ease;
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
  &:active {
    background-color: rgba(0, 0, 0, 0.1);
  }
  svg {
    @extend %icon-std;
    margin-top: $margin-xs;
  }
}
.nav-details {
  a {
    display: block;
    color: $font-secondary-color;
    padding: $padding-xs 0px;
    &:hover {
      color: darken($font-secondary-color, 20%);
    }
  }
}
.details-header {
  display: flex;
  align-items: center;
  padding-left: $padding-s;
  margin-bottom: $margin-m;
  h4 {
    margin-left: $margin-xs;
  }
}
.menu-section {
  padding-left: $padding-xl;
  h6 {
    font-size: $header-size-6;
    font-weight: 600;
    margin-left: $margin-l;
  }
  a {
    margin-left: $margin-l;
  }
}
</style>
